export const getSelectedUnits = (selectedUnits: number[], fullList: any[]) =>
	selectedUnits.length ? selectedUnits : fullList.map((item: any) => item.id);
